module.exports = __webpack_public_path__ + "static/media/grb_gold.3123c44a.png";